module.exports = __webpack_public_path__ + "img/Wellness@2x.7ba3a834.png";